<template>
  <!-- playlist section -->
  <section class="playlist_wrapper" v-if="spotifyAlbums.length">
    <div class="container">

      <div class="playlist_head">
        <div class="playlist_title">
          <img src="@/assets/images/spotify-playlists.svg" alt="spotify-playlists.svg">
        </div>

        <div class="follow_list">
          <a href="https://open.spotify.com/artist/3UGhltIiwrExCxs5CjJQFh" target="_blank" class="btn btn_primary btn_follow"><i class="fab fa-spotify"></i> Follow us</a>
        </div>

      </div>

      <section class="playlist_slider">
        <ul>
          <VueSlick v-bind="slickSettings">
            <li v-for="(album, index) in spotifyAlbums" :key="index">
              <div class="card playlist_card">
                <img class="card-img-top" :src="album.image" alt="playlist1.svg">
                <div class="card-body">
                  <h4 class="card-title">{{album.name}}</h4>
                  <a :href="album.url" target="_blank" class="btn btn_primary btn_playlist_sub">Subscribe</a>
                </div>
              </div>
            </li>
          </VueSlick>
        </ul>

      </section>
    </div>
  </section>
  <!-- playlist section -->
</template>

<script>
export default {
  name: 'SpotifyPlaylist',
  data () {
    return {
      slickSettings: {
        dots: false,
        infinite: false,
        arrows: true,
        swipeToSlide: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        draggable: true,
        autoplay: false,
        autoplaySpeed: 1500,
        variableWidth: false,
        centerMode: false,
        fade: false,
        cssEase: 'linear',
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 5
          }
        },

        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4
          }
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2
          }
        }
        ]
      },
      spotifyAlbums: []
    }
  },
  mounted () {
    this.fetchSpotifyAlbums()
  },
  methods: {
    fetchSpotifyAlbums () {
      this.$store
        .dispatch('fetchSpotifyAlbums')
        .then((resp) => {
          this.spotifyAlbums = resp.data
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SpotifyPlaylist.vue